export default "__VITE_ASSET__dd56bc03__"